import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { PlanState, ProtectionType, TravelType } from './types'
import { PlanService } from '../../services/plan/PlanService'
import { BannerType } from '../../components/BannerLabel'

export const planExtraBuilderFunction = (builder: ActionReducerMapBuilder<PlanState>) => {
  builder
    .addCase(PlanService.getAllPlansAsyncThunk.pending, (state) => {
      state.isGetAllPlansLoading = true
    })
    .addCase(PlanService.getAllPlansAsyncThunk.rejected, (state) => {
      state.isGetAllPlansLoading = false
    })
    .addCase(PlanService.getAllPlansAsyncThunk.fulfilled, (state, action) => {
      state.plans = action.payload
      state.isGetAllPlansLoading = false
    })
    .addCase(PlanService.exportPlansAsyncThunk.pending, (state) => {
      state.isExportPlansLoading = true
    })
    .addCase(PlanService.exportPlansAsyncThunk.rejected, (state) => {
      state.isExportPlansLoading = false
    })
    .addCase(PlanService.exportPlansAsyncThunk.fulfilled, (state) => {
      state.isExportPlansLoading = false
    })
    .addCase(PlanService.addPlanAsyncThunk.pending, (state) => {
      state.isAddPlanLoading = true
    })
    .addCase(PlanService.addPlanAsyncThunk.rejected, (state) => {
      state.isAddPlanLoading = false
    })
    .addCase(PlanService.addPlanAsyncThunk.fulfilled, (state) => {
      state.isAddPlanLoading = false
    })
    .addCase(PlanService.deletePlanByIdAsyncThunk.pending, (state) => {
      state.isDeletePlanLoading = true
    })
    .addCase(PlanService.deletePlanByIdAsyncThunk.rejected, (state) => {
      state.isDeletePlanLoading = false
    })
    .addCase(PlanService.deletePlanByIdAsyncThunk.fulfilled, (state) => {
      state.isDeletePlanLoading = false
    })
    .addCase(PlanService.downloadCountryTemplateAsyncThunk.pending, (state) => {
      state.isDownloadCountryTemplateLoading = true
    })
    .addCase(PlanService.downloadCountryTemplateAsyncThunk.rejected, (state) => {
      state.isDownloadCountryTemplateLoading = false
    })
    .addCase(PlanService.downloadCountryTemplateAsyncThunk.fulfilled, (state) => {
      state.isDownloadCountryTemplateLoading = false
    })
    .addCase(PlanService.getCountryIdListFromExcelAsyncThunk.pending, (state) => {
      state.isGetCountryIdListFromExcelLoading = true
    })
    .addCase(PlanService.getCountryIdListFromExcelAsyncThunk.rejected, (state) => {
      state.isGetCountryIdListFromExcelLoading = false
    })
    .addCase(PlanService.getCountryIdListFromExcelAsyncThunk.fulfilled, (state, action) => {
      state.isGetCountryIdListFromExcelLoading = false
      state.selectedPlanCountries = action.payload
    })
    .addCase(PlanService.exportPlanCountryByIdAsyncThunk.pending, (state) => {
      state.isExportPlanCountryByIdLoading = true
    })
    .addCase(PlanService.exportPlanCountryByIdAsyncThunk.rejected, (state) => {
      state.isExportPlanCountryByIdLoading = false
    })
    .addCase(PlanService.exportPlanCountryByIdAsyncThunk.fulfilled, (state) => {
      state.isExportPlanCountryByIdLoading = false
    })
    .addCase(PlanService.downloadPriceTemplateAsyncThunk.pending, (state) => {
      state.isDownloadPriceTemplateLoading = true
    })
    .addCase(PlanService.downloadPriceTemplateAsyncThunk.rejected, (state) => {
      state.isDownloadPriceTemplateLoading = false
    })
    .addCase(PlanService.downloadPriceTemplateAsyncThunk.fulfilled, (state) => {
      state.isDownloadPriceTemplateLoading = false
    })
    .addCase(PlanService.getPriceListFromExcelAsyncThunk.pending, (state) => {
      state.isGetPriceListFromExcelLoading = true
    })
    .addCase(PlanService.getPriceListFromExcelAsyncThunk.rejected, (state) => {
      state.isGetPriceListFromExcelLoading = false
    })
    .addCase(PlanService.getPriceListFromExcelAsyncThunk.fulfilled, (state, action) => {
      state.isGetPriceListFromExcelLoading = false
      state.prices = action.payload
    })
    .addCase(PlanService.exportPlanPriceByIdAsyncThunk.pending, (state) => {
      state.isExportPlanPriceByIdLoading = true
    })
    .addCase(PlanService.exportPlanPriceByIdAsyncThunk.rejected, (state) => {
      state.isExportPlanPriceByIdLoading = false
    })
    .addCase(PlanService.exportPlanPriceByIdAsyncThunk.fulfilled, (state) => {
      state.isExportPlanPriceByIdLoading = false
    })
    .addCase(PlanService.getPlanStatusAsyncThunk.pending, (state) => {
      state.isGetPlanStatusLoading = true
    })
    .addCase(PlanService.getPlanStatusAsyncThunk.rejected, (state) => {
      state.isGetPlanStatusLoading = false
    })
    .addCase(PlanService.getPlanStatusAsyncThunk.fulfilled, (state, action) => {
      state.isGetPlanStatusLoading = false
      state.isPlanActive = action.payload
    })
    .addCase(PlanService.getPlanInfoAsyncThunk.pending, (state) => {
      state.isGetPlanInfoLoading = true
    })
    .addCase(PlanService.getPlanInfoAsyncThunk.rejected, (state) => {
      state.isGetPlanInfoLoading = false
    })
    .addCase(PlanService.getPlanInfoAsyncThunk.fulfilled, (state, action) => {
      state.isGetPlanInfoLoading = false
      state.planInfo = action.payload
    })
    .addCase(PlanService.getPlanTypeAsyncThunk.pending, (state) => {
      state.isGetPlanTypeLoading = true
    })
    .addCase(PlanService.getPlanTypeAsyncThunk.rejected, (state) => {
      state.isGetPlanTypeLoading = false
    })
    .addCase(PlanService.getPlanTypeAsyncThunk.fulfilled, (state, action) => {
      state.isGetPlanTypeLoading = false
      state.travelType = action.payload.travelType as TravelType
      state.protectionType = action.payload.protectionType as ProtectionType
    })
    .addCase(PlanService.getPlanCountriesAsyncThunk.pending, (state) => {
      state.isGetPlanCountriesLoading = true
    })
    .addCase(PlanService.getPlanCountriesAsyncThunk.rejected, (state) => {
      state.isGetPlanCountriesLoading = false
    })
    .addCase(PlanService.getPlanCountriesAsyncThunk.fulfilled, (state, action) => {
      state.isGetPlanCountriesLoading = false
      state.planCountries = action.payload
      state.selectedPlanCountries = action.payload
    })
    .addCase(PlanService.getPlanPricesAsyncThunk.pending, (state) => {
      state.isGetPlanPricesLoading = true
    })
    .addCase(PlanService.getPlanPricesAsyncThunk.rejected, (state) => {
      state.isGetPlanPricesLoading = false
    })
    .addCase(PlanService.getPlanPricesAsyncThunk.fulfilled, (state, action) => {
      state.isGetPlanPricesLoading = false
      state.planPrices = action.payload
      state.prices = action.payload.prices
      state.yearPrice = action.payload.yearPrice ? action.payload.yearPrice.toString() : ''
      state.tax = action.payload.tax ? action.payload.tax.toString() : ''
      state.insurancePrice = action.payload.insurancePrice ? action.payload.insurancePrice.toString() : ''
    })
    .addCase(PlanService.getPlanSpecialLabelAsyncThunk.pending, (state) => {
      state.isGetPlanSpecialLabelLoading = true
    })
    .addCase(PlanService.getPlanSpecialLabelAsyncThunk.rejected, (state) => {
      state.isGetPlanSpecialLabelLoading = false
    })
    .addCase(PlanService.getPlanSpecialLabelAsyncThunk.fulfilled, (state, action) => {
      state.isGetPlanSpecialLabelLoading = false
      state.bannerType = action.payload as BannerType
    })
    .addCase(PlanService.getPlanDetailAsyncThunk.pending, (state) => {
      state.isGetPlanDetailLoading = true
    })
    .addCase(PlanService.getPlanDetailAsyncThunk.rejected, (state) => {
      state.isGetPlanDetailLoading = false
    })
    .addCase(PlanService.getPlanDetailAsyncThunk.fulfilled, (state, action) => {
      state.isGetPlanDetailLoading = false
      state.planDetail = action.payload
    })
    .addCase(PlanService.getPlanExceptionAsyncThunk.pending, (state) => {
      state.isGetPlanExceptionLoading = true
    })
    .addCase(PlanService.getPlanExceptionAsyncThunk.rejected, (state) => {
      state.isGetPlanExceptionLoading = false
    })
    .addCase(PlanService.getPlanExceptionAsyncThunk.fulfilled, (state, action) => {
      state.isGetPlanExceptionLoading = false
      state.planException = action.payload
    })
    .addCase(PlanService.getPlanTimestampAsyncThunk.pending, (state) => {
      state.isGetPlanTimestampLoading = true
    })
    .addCase(PlanService.getPlanTimestampAsyncThunk.rejected, (state) => {
      state.isGetPlanTimestampLoading = false
    })
    .addCase(PlanService.getPlanTimestampAsyncThunk.fulfilled, (state, action) => {
      state.isGetPlanTimestampLoading = false
      state.planTimestampDetail = action.payload
    })
    .addCase(PlanService.updatePlanStatusAsyncThunk.pending, (state) => {
      state.isUpdatePlanStatusLoading = true
    })
    .addCase(PlanService.updatePlanStatusAsyncThunk.rejected, (state) => {
      state.isUpdatePlanStatusLoading = false
    })
    .addCase(PlanService.updatePlanStatusAsyncThunk.fulfilled, (state) => {
      state.isUpdatePlanStatusLoading = false
    })
    .addCase(PlanService.updatePlanInfoAsyncThunk.pending, (state) => {
      state.isUpdatePlanInfoLoading = true
    })
    .addCase(PlanService.updatePlanInfoAsyncThunk.rejected, (state) => {
      state.isUpdatePlanInfoLoading = false
    })
    .addCase(PlanService.updatePlanInfoAsyncThunk.fulfilled, (state) => {
      state.isUpdatePlanInfoLoading = false
    })
    .addCase(PlanService.updatePlanTypeAsyncThunk.pending, (state) => {
      state.isUpdatePlanTypeLoading = true
    })
    .addCase(PlanService.updatePlanTypeAsyncThunk.rejected, (state) => {
      state.isUpdatePlanTypeLoading = false
    })
    .addCase(PlanService.updatePlanTypeAsyncThunk.fulfilled, (state) => {
      state.isUpdatePlanTypeLoading = false
    })
    .addCase(PlanService.updatePlanCountriesAsyncThunk.pending, (state) => {
      state.isUpdatePlanCountriesLoading = true
    })
    .addCase(PlanService.updatePlanCountriesAsyncThunk.rejected, (state) => {
      state.isUpdatePlanCountriesLoading = false
    })
    .addCase(PlanService.updatePlanCountriesAsyncThunk.fulfilled, (state) => {
      state.isUpdatePlanCountriesLoading = false
    })
    .addCase(PlanService.updatePlanPricesAsyncThunk.pending, (state) => {
      state.isUpdatePlanPricesLoading = true
    })
    .addCase(PlanService.updatePlanPricesAsyncThunk.rejected, (state) => {
      state.isUpdatePlanPricesLoading = false
    })
    .addCase(PlanService.updatePlanPricesAsyncThunk.fulfilled, (state) => {
      state.isUpdatePlanPricesLoading = false
    })
    .addCase(PlanService.updatePlanSpecialLabelAsyncThunk.pending, (state) => {
      state.isUpdateSpecialLabelLoading = true
    })
    .addCase(PlanService.updatePlanSpecialLabelAsyncThunk.rejected, (state) => {
      state.isUpdateSpecialLabelLoading = false
    })
    .addCase(PlanService.updatePlanSpecialLabelAsyncThunk.fulfilled, (state) => {
      state.isUpdateSpecialLabelLoading = false
    })
    .addCase(PlanService.updatePlanDetailAsyncThunk.pending, (state) => {
      state.isUpdatePlanDetailLoading = true
    })
    .addCase(PlanService.updatePlanDetailAsyncThunk.rejected, (state) => {
      state.isUpdatePlanDetailLoading = false
    })
    .addCase(PlanService.updatePlanDetailAsyncThunk.fulfilled, (state) => {
      state.isUpdatePlanDetailLoading = false
    })
    .addCase(PlanService.updatePlanExceptionAsyncThunk.pending, (state) => {
      state.isUpdatePlanExceptionLoading = true
    })
    .addCase(PlanService.updatePlanExceptionAsyncThunk.rejected, (state) => {
      state.isUpdatePlanExceptionLoading = false
    })
    .addCase(PlanService.updatePlanExceptionAsyncThunk.fulfilled, (state) => {
      state.isUpdatePlanExceptionLoading = false
    })
    .addCase(PlanService.importPlanTemplateAsyncThunk.pending, (state) => {
      state.isImportPlanTemplateLoading = true
    })
    .addCase(PlanService.importPlanTemplateAsyncThunk.rejected, (state) => {
      state.isImportPlanTemplateLoading = false
    })
    .addCase(PlanService.importPlanTemplateAsyncThunk.fulfilled, (state) => {
      state.isImportPlanTemplateLoading = false
    })
    .addCase(PlanService.downloadPlanTemplateAsyncThunk.pending, (state) => {
      state.isDownloadPlanTemplateLoading = true
    })
    .addCase(PlanService.downloadPlanTemplateAsyncThunk.rejected, (state) => {
      state.isDownloadPlanTemplateLoading = false
    })
    .addCase(PlanService.downloadPlanTemplateAsyncThunk.fulfilled, (state) => {
      state.isDownloadPlanTemplateLoading = false
    })
}
